/**
 * @generated SignedSource<<f198e55c82a22f033ac5dd8ed6191f6b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgSpaceActiveInfoScreen_workspace$data = {
  readonly id: string;
  readonly space: {
    readonly stores: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"OrgSpaceActiveInfoScreenListItem_SpaceActiveConnectionNode">;
        };
      }>;
    };
  };
  readonly " $fragmentType": "OrgSpaceActiveInfoScreen_workspace";
};
export type OrgSpaceActiveInfoScreen_workspace$key = {
  readonly " $data"?: OrgSpaceActiveInfoScreen_workspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgSpaceActiveInfoScreen_workspace">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "space",
  "stores"
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "spaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./OrgSpaceActiveInfoScreen_workspacePaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "OrgSpaceActiveInfoScreen_workspace",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "spaceId"
        }
      ],
      "concreteType": "StorecastSpace",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        {
          "alias": "stores",
          "args": null,
          "concreteType": "SpaceActiveConnection",
          "kind": "LinkedField",
          "name": "__OrgSpaceActiveInfoScreen_workspace_active_stores_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SpaceActiveConnectionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SpaceActiveConnectionNode",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "OrgSpaceActiveInfoScreenListItem_SpaceActiveConnectionNode"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "a489cd5bf8790587525cc56b564ad2ae";

export default node;
